/**
 * The below file is the Landslide Non Inmates Registration service which contains method for doing the API calls.
 * @author: vishal.mishra@velsof.com
 * @date : 01-04-2024
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Landslide_Create_Non_Inmates_Registration,
  Landslide_Export_Non_Inmates_Registration,
  Landslide_Import_Non_Inmates_Registration,
  Multipart_Form_Data,
  Blob,
  Landslide_Import_Non_Inmates_Registration_Xlsx,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const LandslideNonInmatesRegistrationServices = {};

//#region Method for Landslide Freeze Report listing page.

/**
 * Method for getting the Landslide Freeze Report listing
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
LandslideNonInmatesRegistrationServices.getAll = function (param) {
  return fetch({
    url: Landslide_Create_Non_Inmates_Registration,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    params: param,
  });
};

//#region Method for Landslide Freeze Report .

/**
 * Method for importing the Landslide Freeze Report
 * @param {any} data API Data
 * @returns Fetch Method
 */
LandslideNonInmatesRegistrationServices.create = function (data) {
  return fetch({
    url: Landslide_Create_Non_Inmates_Registration,
    method: "post",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    data: data,
  });
};

//#endregion Method for Landslide Freeze Report .

/**
 * Method for importing the Landslide Freeze Report
 * @param {any} data API Data
 * @returns Fetch Method
 */
LandslideNonInmatesRegistrationServices.update = function (data, id) {
  return fetch({
    url: Landslide_Create_Non_Inmates_Registration + `/${id}`,
    method: "put",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    data: data,
  });
};

//#endregion Method for Landslide Freeze Report .

/**
 * Method for importing the Non Camp Inmates Registration
 * @param {any} data API data
 * @returns Fetch Method
 */
LandslideNonInmatesRegistrationServices.nonCampInmatesRegistrationImport =
  function (data) {
    return fetch({
      url: Landslide_Import_Non_Inmates_Registration,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: data,
    });
  };

/**
 * Method for importing the Non Camp Inmates Registration Excel
 * @param {any} data API data
 * @returns Fetch Method
 */
LandslideNonInmatesRegistrationServices.nonCampInmatesRegistrationImportExcel =
  function (data) {
    return fetch({
      url: Landslide_Import_Non_Inmates_Registration_Xlsx,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: data,
    });
  };

/**
 * Method for getting the Non Camp Inmates Registration export data
 * @returns Fetch Method
 */
LandslideNonInmatesRegistrationServices.getExportNonInmatesRegistrationData =
  function (payload) {
    return fetch({
      url: Landslide_Export_Non_Inmates_Registration,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: payload,
      responseType: Blob,
    });
  };

export default LandslideNonInmatesRegistrationServices;
